import SpinLoad from '../../../components/SpinLoad';
import {
  Button,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  notification,
  Select,
  Switch,
  TimePicker,
  Upload,
} from 'antd';
import { DeleteFilled, HddFilled, PaperClipOutlined, SaveFilled } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import TextArea from 'antd/es/input/TextArea';
import dayjs from 'dayjs';
import { catchException } from '../../../utils/helpers/helpers';
import {
  createFillOutFormQuestion,
  deleteFillOutFormQuestion,
  updateFillOutFormQuestion,
} from '../../../api/module/fill_out_form_question';
import MESSAGES from '../../../enums/Messages';
import Title from 'antd/es/typography/Title';
import Paragraph from 'antd/es/typography/Paragraph';
import { setFillOutFormCompleted, updateFillOutForm } from '../../../api/module/fill_out_form';

export default function QuestionSection({ questions, fillOutFormId, loadingQuestions, reload, nextSection }) {
  const [form] = Form.useForm();
  const [loadingSave, setLoadingSave] = useState(false);
  const [fileList, setFileList] = useState({});

  const validateText = (obligatorio, validations) => {
    let rules = [{ required: obligatorio }];
    validations.forEach((validation) => {
      if (validation.validacion === 1) {
        rules.push({
          validator: (_, value) => {
            if (value.length > parseInt(validation.valor_inicial)) {
              return Promise.reject(new Error(validation.error_message));
            }
            return Promise.resolve();
          }
        });
      }
      if (validation.validacion === 2) {
        rules.push({
          validator: (_, value) => {
            if (value.length < parseInt(validation.valor_inicial)) {
              return Promise.reject(new Error(validation.error_message));
            }
            return Promise.resolve();
          }
        });
      }
      if (validation.validacion === 3) {
        rules.push({
          validator: (_, value) => {
            if (!value.toLowerCase().includes(validation.valor_inicial.toLowerCase())) {
              return Promise.reject(new Error(validation.error_message));
            }
            return Promise.resolve();
          }
        });
      }
      if (validation.validacion === 4) {
        rules.push({
          validator: (_, value) => {
            if (value.toLowerCase().includes(validation.valor_inicial.toLowerCase())) {
              return Promise.reject(new Error(validation.error_message));
            }
            return Promise.resolve();
          }
        });
      }
    });
    return rules;
  };

  const validateDates = (obligatorio, validations, format) => {
    let rules = [{ required: obligatorio }];
    validations.forEach((validation) => {
      let vi = dayjs(validation.valor_inicial, format);
      let vf;
      if (validation.valor_final !== null)
        vf = dayjs(validation.valor_final, format)

      if (validation.validacion === 5) {
        rules.push({
          validator: (_, value) => {
            if (dayjs(value, format).isBefore(vi)) {
              return Promise.reject(new Error(validation.error_message));
            }
            return Promise.resolve();
          }
        });
      }
      if (validation.validacion === 6) {
        rules.push({
          validator: (_, value) => {
            if (dayjs(value, format).isSame(vi) || dayjs(value, format).isBefore(vi)) {
              return Promise.reject(new Error(validation.error_message));
            }
            return Promise.resolve();
          }
        });
      }
      if (validation.validacion === 7) {
        rules.push({
          validator: (_, value) => {
            if (dayjs(value, format).isAfter(vi)) {
              return Promise.reject(new Error(validation.error_message));
            }
            return Promise.resolve();
          }
        });
      }
      if (validation.validacion === 8) {
        rules.push({
          validator: (_, value) => {
            if (dayjs(value, format).isSame(vi) || dayjs(value, format).isAfter(vi)) {
              return Promise.reject(new Error(validation.error_message));
            }
            return Promise.resolve();
          }
        });
      }
      if (validation.validacion === 9) {
        rules.push({
          validator: (_, value) => {
            if (dayjs(value, format).isAfter(vi) || dayjs(value, format).isBefore(vf)) {
              return Promise.reject(new Error(validation.error_message));
            }
            return Promise.resolve();
          }
        });
      }
      if (validation.validacion === 10) {
        rules.push({
          validator: (_, value) => {
            if (dayjs(value, format).isSame(vi)) {
              return Promise.reject(new Error(validation.error_message));
            }
            return Promise.resolve();
          }
        });
      }
      if (validation.validacion === 11) {
        rules.push({
          validator: (_, value) => {
            if (!dayjs(value, format).isSame(vi)) {
              return Promise.reject(new Error(validation.error_message));
            }
            return Promise.resolve();
          }
        });
      }
      if (validation.validacion === 12) {
        rules.push({
          validator: (_, value) => {
            if (dayjs(value, format).isBefore(vi) || dayjs(value, format).isAfter(vf)) {
              return Promise.reject(new Error(validation.error_message));
            }
            return Promise.resolve();
          }
        });
      }
    });
    return rules;
  };

  const validateNumbers = (obligatorio, validations, type) => {
    let rules = [{ required: obligatorio }];
    validations.forEach((validation) => {
      let vi;
      let vf;
      if (type === 'number') {
        vi = parseInt(validation.valor_inicial)
        if (validation.valor_final !== null)
          vf = parseInt(validation.valor_final)
      } else {
        vi = parseFloat(validation.valor_inicial)
        if (validation.valor_final !== null)
          vf = parseFloat(validation.valor_final)
      }
      if (validation.validacion === 5) {
        rules.push({
          validator: (_, value) => {
            if (value < vi) {
              return Promise.reject(new Error(validation.error_message));
            }
            return Promise.resolve();
          }
        });
      }
      if (validation.validacion === 6) {
        rules.push({
          validator: (_, value) => {
            if (value <= vi) {
              return Promise.reject(new Error(validation.error_message));
            }
            return Promise.resolve();
          }
        });
      }
      if (validation.validacion === 7) {
        rules.push({
          validator: (_, value) => {
            if (value > vi) {
              return Promise.reject(new Error(validation.error_message));
            }
            return Promise.resolve();
          }
        });
      }
      if (validation.validacion === 8) {
        rules.push({
          validator: (_, value) => {
            if (value >= vi) {
              return Promise.reject(new Error(validation.error_message));
            }
            return Promise.resolve();
          }
        });
      }
      if (validation.validacion === 9) {
        rules.push({
          validator: (_, value) => {
            if (value > vi || value < vf) {
              return Promise.reject(new Error(validation.error_message));
            }
            return Promise.resolve();
          }
        });
      }
      if (validation.validacion === 10) {
        rules.push({
          validator: (_, value) => {
            if (value === vi) {
              return Promise.reject(new Error(validation.error_message));
            }
            return Promise.resolve();
          }
        });
      }
      if (validation.validacion === 11) {
        rules.push({
          validator: (_, value) => {
            if (value !== vi) {
              return Promise.reject(new Error(validation.error_message));
            }
            return Promise.resolve();
          }
        });
      }
      if (validation.validacion === 12) {
        rules.push({
          validator: (_, value) => {
            if (value < vi || value > vf) {
              return Promise.reject(new Error(validation.error_message));
            }
            return Promise.resolve();
          }
        });
      }
    });
    return rules;
  };

  const convertDataForm = () => {
    let data = {};
    questions.filter(a => a.activa).forEach((q) => {
      let key = `${q.etiqueta}_*_${q.id}_${q.diligenciamiento?.id ?? ''}`;
      switch (q.tipo.id) {
        case 1:
          data[key.replace('*', 'SU')] = q.diligenciamiento?.string_value ? q.diligenciamiento?.string_value : null;
          break;
        case 2:
          data[key.replace('*', 'SM')] = q.diligenciamiento?.string_value ? JSON.parse(q.diligenciamiento?.string_value) : null;
          break;
        case 4:
          data[key.replace('*', 'CF')] = q.diligenciamiento?.date_value ? dayjs(q.diligenciamiento?.date_value, 'YYYY-MM-DD') : null;
          break;
        case 5:
          data[key.replace('*', 'CT')] = q.diligenciamiento?.time_value ? dayjs(q.diligenciamiento?.time_value, 'HH:mm:ss') : null;
          break;
        case 6:
          data[key.replace('*', 'CN')] = q.diligenciamiento?.int_value ? q.diligenciamiento?.int_value : null;
          break;
        case 10:
          data[key.replace('*', 'TL')] = q.diligenciamiento?.text_value ? q.diligenciamiento?.text_value : null;
          break;
        case 11:
          data[key.replace('*', 'FH')] = q.diligenciamiento?.datetime_value ? dayjs(q.diligenciamiento?.datetime_value) : null;
          break;
        case 12:
          data[key.replace('*', 'CB')] = q.diligenciamiento?.bool_value ? q.diligenciamiento?.bool_value : null;
          break;
        case 13:
          data[key.replace('*', 'CD')] = q.diligenciamiento?.float_value ? q.diligenciamiento?.float_value : null;
          break;
        default:
          data[key.replace('*', 'TC')] = q.diligenciamiento?.string_value ? q.diligenciamiento?.string_value : null;
      }
    });
    return data;
  };

  const transformDataToSave = (structure, value) => {
    let data = null;
    if (value !== null && value !== undefined) {
      data = { 'pregunta': parseInt(structure[1]), 'diligenciamiento_formulario': parseInt(fillOutFormId) }
      const check = (field, type = null) => structure[0] === '' ||
        questions.filter(q => q.id === parseInt(structure[1])).some(v => {
          let newValue = value
          switch (type) {
            case 'CF':
              newValue = value.format('YYYY-MM-DD');
              break;
            case 'SM':
              newValue = JSON.stringify(value);
              break;
            case 'CT':
              newValue = value.format('HH:mm:ss');
              break;
          }
          return v.diligenciamiento[`${field}`] !== newValue;
        });
      switch (structure[2]) {
        case 'CF':
          (check("date_value", 'CF')) ? data['date_value'] = value.format('YYYY-MM-DD') : data = null;
          break;
        case 'CT':
          (check("time_value", "CT")) ? data['time_value'] = value.format('HH:mm:ss') : data = null;
          break;
        case 'CN':
          (check("int_value")) ? data['int_value'] = value : data = null;
          break;
        case 'CD':
          (check("float_value")) ? data['float_value'] = value : data = null;
          break;
        case 'TL':
          (check("text_value")) ? data['text_value'] = value : data = null;
          break;
        case 'FH':
          data['datetime_value'] = value;
          break;
        case 'CB':
          (check("bool_value")) ? data['bool_value'] = value : data = null;
          break;
        case 'SM':
          (check("string_value", "SM")) ? data['string_value'] = JSON.stringify(value) : data = null;
          break;
        case 'CA':
          data['file_value'] = value;
          break;
        default:
          (check("string_value")) ? data['string_value'] = value : data = null;
      }
    }
    return data;
  };

  const saveData = async (values) => {
    try {
      for (const [k, v] of Object.entries(values)) {
        let structure = k.split('_').reverse();
        let d = transformDataToSave(structure, v);
        if (d !== null && d !== undefined) {
          const formData = new FormData();
          for (const prop in d) formData.append(prop, d[prop]);
          if (structure[0] !== '') {
            await updateFillOutFormQuestion(structure[0], formData);
          } else {
            await createFillOutFormQuestion(formData);
          }
        }
      }
      notification.success({
        message: MESSAGES.SUCCESS_MSG,
        description: MESSAGES.DESC_SUCCESS_MSG,
        duration: 2,
      });
    } catch (e) {
      catchException(e);
    }
  };

  const saveDraft = async () => {
    setLoadingSave(true);
    let data = { ...form.getFieldsValue(), ...fileList };
    await saveData(data);
    await updateFillOutForm(fillOutFormId, {"estado": 'Borrador'});
    setLoadingSave(false);
    reload(questions[0].seccion.id);
  };

  const saveFull = async (values) => {
    setLoadingSave(true);
    try {
      await saveData({ ...values, ...fileList });
      await setFillOutFormCompleted({ "diligenciamiento": fillOutFormId });
    } catch (error) {
      catchException(error);
    } finally {
      setLoadingSave(false);
      if (questions[0].seccion.siguiente_section !== null) {
        nextSection();
      } else {
        reload(questions[0].seccion.id);
      }
    }
  };

  useEffect(() => {
    let data = convertDataForm();
    form.setFieldsValue(data);
  }, [questions, form]);

  return (
    <SpinLoad loading={loadingQuestions}>
      <Form
        form={form}
        layout="vertical"
        name={'questions_section'}
        onFinish={saveFull}
        preserve={false}
      >
        {questions.filter(q => q.activa).map(question => {
          let name = `${question.etiqueta}_*_${question.id}_${question.diligenciamiento?.id ?? ''}`;
          switch (question.tipo.id) {
            case 1:
              return (
                <Form.Item
                  label={question.nombre}
                  name={name.replace('*', 'SU')}
                  key={question.id}
                  tooltip={question.tooltip}
                  rules={[{ required: question.obligatorio }]}
                >
                  <Select
                    options={question.question_option.filter(o => o.activa).map(option => ({
                      label: option.opcion,
                      value: option.id.toString(),
                    }))}
                  />
                </Form.Item>
              );
            case 2:
              return (
                <Form.Item
                  label={question.nombre}
                  name={name.replace('*', 'SM')}
                  key={question.id}
                  tooltip={question.tooltip}
                  rules={[{ required: question.obligatorio }]}
                >
                  <Select
                    mode="multiple"
                    allowClear
                    optionFilterProp="label"
                    options={question.question_option.map(option => ({
                      label: option.opcion,
                      value: option.id.toString(),
                    }))}
                  />
                </Form.Item>
              );
            case 4:
              return (
                <Form.Item
                  label={question.nombre}
                  name={name.replace('*', 'CF')}
                  key={question.id}
                  tooltip={question.tooltip}
                  rules={validateDates(question.obligatorio, question.question_validation, 'YYYY-MM-DD')}
                >
                  <DatePicker format="YYYY-MM-DD" />
                </Form.Item>
              );
            case 5:
              return (
                <Form.Item
                  label={question.nombre}
                  name={name.replace('*', 'CT')}
                  key={question.id}
                  tooltip={question.tooltip}
                  rules={validateDates(question.obligatorio, question.question_validation, 'HH:mm:ss')}
                >
                  <TimePicker format="HH:mm:ss" />
                </Form.Item>
              );
            case 6:
              return (
                <Form.Item
                  label={question.nombre}
                  name={name.replace('*', 'CN')}
                  key={question.id}
                  tooltip={question.tooltip}
                  rules={validateNumbers(question.obligatorio, question.question_validation, 'number')}
                >
                  <InputNumber />
                </Form.Item>
              );
            case 7:
              return (
                <>
                <Form.Item
                  label={question.nombre}
                  name={name.replace('*', 'CA')}
                  key={question.id}
                  tooltip={question.tooltip}
                  rules={[{ required: question.obligatorio }]}
                >
                  <Upload
                    listType="picture"
                    maxCount={1}
                    defaultFileList={
                      question?.diligenciamiento?.file_name !== undefined ?
                      [
                        {
                          uid: '-1',
                          name: question.diligenciamiento?.file_name,
                          status: 'done',
                          url: question.diligenciamiento?.file_value,
                        },
                      ] : []
                    }
                    onRemove={async (file) => {
                      if (file.url) {
                        await deleteFillOutFormQuestion(question.diligenciamiento?.id);
                        reload(question.seccion.id);
                      }
                    }}
                    beforeUpload={(file) => {
                      setFileList({ ...fileList, [name.replace('*', 'CA')]: file });
                      return false;
                    }}
                    showUploadList={{
                      showRemoveIcon: true,
                      removeIcon: <DeleteFilled style={{ fontSize: '16px', color: 'red' }}/>
                    }}
                  >
                    <Input
                      prefix={question.diligenciamiento?.file_name && <PaperClipOutlined />}
                      suffix={
                        <Button htmlType="button">Seleccionar Archivo</Button>
                      }
                    />
                  </Upload>
                </Form.Item>
                </>
              );
            case 8:
              return (
                <Form.Item
                  label={question.nombre}
                  name={name.replace('*', 'CU')}
                  key={question.id}
                  tooltip={question.tooltip}
                  rules={[
                    { required: question.obligatorio },
                    { type: 'url', message: 'El campo debe estar en la forma de dirección URL.' },
                  ]}
                  required={question.obligatorio}
                >
                  <Input />
                </Form.Item>
              );
            case 9:
              return (
                <>
                  <Title level={3}>{question.nombre}</Title>
                  <Paragraph>{question.tooltip}</Paragraph>
                  <Divider />
                </>
              );
            case 10:
              return (
                <Form.Item
                  label={question.nombre}
                  name={name.replace('*', 'TL')}
                  key={question.id}
                  tooltip={question.tooltip}
                  rules={validateText(question.obligatorio, question.question_validation)}
                >
                  <TextArea />
                </Form.Item>
              );
            case 11:
              return (
                <Form.Item
                  label={question.nombre}
                  name={name.replace('*', 'FH')}
                  key={question.id}
                  tooltip={question.tooltip}
                  rules={validateDates(question.obligatorio, question.question_validation, 'YYYY-MM-DD HH:mm:ss')}
                >
                  <DatePicker format="'YYYY-MM-DD HH:mm:ss" showTime />
                </Form.Item>
              );
            case 12:
              return (
                <Form.Item
                  label={question.nombre}
                  name={name.replace('*', 'CB')}
                  key={question.id}
                  tooltip={question.tooltip}
                  rules={[{ required: question.obligatorio }]}
                  valuePropName="checked"
                >
                  <Switch />
                </Form.Item>
              );
            case 13:
              return (
                <Form.Item
                  label={question.nombre}
                  name={name.replace('*', 'CD')}
                  key={question.id}
                  tooltip={question.tooltip}
                  rules={validateNumbers(question.obligatorio, question.question_validation, 'decimal')}
                >
                  <InputNumber stringMode />
                </Form.Item>
              );
            default:
              return (
                <Form.Item
                  label={question.nombre}
                  key={question.id}
                  tooltip={question.tooltip}
                  name={name.replace('*', 'TC')}
                  rules={validateText(question.obligatorio, question.question_validation)}
                >
                  <Input />
                </Form.Item>
              );
          }
        })}
        {questions.length > 0 && (
          <Form.Item justify={'left'}>
            <Button
              icon={<HddFilled />}
              onClick={() => {
                saveDraft().then(r => {});
              }}
              loading={loadingSave}
            >Guardar Borrador</Button>
            <Button
              style={{ marginLeft: '20px' }}
              type="primary"
              icon={<SaveFilled />}
              htmlType="submit"
              loading={loadingSave}
            >Finalizar Sección</Button>
          </Form.Item>
        )}
      </Form>
    </SpinLoad>
  );
};
